import { IEditedNameCardIdSetAction } from './types';
import { AT_EDITED_NAME_CARD_ID } from './constants';
import { TCardId } from '../../../../../../types/types';

export const editedNameCardIdSet = (
    cardId: TCardId
): IEditedNameCardIdSetAction => {
    return {
        type: AT_EDITED_NAME_CARD_ID,
        cardId
    }
};
